import { cn } from '@cocoonspace/ui/lib/utils'

export const ProviderWrapper = ({
	children,
	isActive,
	dense = false,
}: {
	children: React.ReactNode
	isActive: boolean
	dense?: boolean
}) => (
	<div
		className={cn(
			'flex flex-col gap-2 p-4 max-md:gap-4 md:flex-row md:items-center',
			{
				'flex-row': isActive,
				'p-0': dense,
			},
		)}
	>
		{children}
	</div>
)

export const ProviderDescription = ({
	children,
}: {
	children: React.ReactNode
}) => <div className='flex flex-1 items-center gap-2'>{children}</div>

export const ProviderName = ({
	children,
	dense = false,
}: {
	children: React.ReactNode
	dense?: boolean
}) => <span className={cn({ 'text-sm': dense })}>{children}</span>
